import clsx from "clsx";
import styles from "./styles.module.css";
import { SeekBar } from "../SeekBar";
import { TimeDisplay } from "../TimeDisplay";
import { useVideoPlayerRefs } from "../../contexts/VideoPlayerRefs";
import { useControlBar } from "../../contexts/ControlBar";
import { SeekControls } from "../SeekControls";
import { Label } from "./Label";
import { Actions } from "../Actions";
import { useRoot } from "../../contexts/Root";
import { useMarkers } from "../../contexts/Markers";
import { EdgeLabel } from "./EdgeLabel";
import { Edge } from "../../types/edge";
import { useLayout } from "../../contexts/Layout";
import { Layout } from "../../types/layout";
import { CenteredSeekControls } from "../SeekControls/Centered";
import { Controls } from "../..";

export const ControlBar = () => {
  const {
    controls,
    theme: { primaryBackground },
  } = useRoot();
  const { controlBar } = useVideoPlayerRefs();
  const { isActive } = useControlBar();
  const { markers } = useMarkers();
  const { layout } = useLayout();

  const isMobile = layout === Layout.mobile;
  const showEdgeLabels = markers.length > 0 && !isMobile;
  const edge = !isMobile ? 12 : 0;
  const showButtons = controls === Controls.fullControlBar;
  const padding = !showButtons ? "0 10px 0 10px" : "5px 15px 10px 15px";

  const style = {
    background: primaryBackground,
    bottom: edge,
    height: showButtons ? 70 : 35,
    padding,
    left: edge,
    right: edge,
    borderRadius: edge,
  };

  const containerClass = clsx(
    styles.container,
    !isActive && styles.containerHide
  );

  return (
    <div style={style} className={containerClass} ref={controlBar}>
      <div className={styles.row}>
        {showEdgeLabels && <EdgeLabel edge={Edge.start} />}
        <SeekBar />
        {showEdgeLabels && <EdgeLabel edge={Edge.end} />}
      </div>

      {showButtons && (
        <div className={styles.row}>
          <div className={styles.left}>
            {!isMobile ? <SeekControls /> : <CenteredSeekControls />}
            <Label />
          </div>
          <div className={styles.right}>
            {!isMobile && <TimeDisplay />}
            <Actions />
          </div>
        </div>
      )}
    </div>
  );
};
